import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './deviceControllers.html'

/**
 * Administer Device Controllers route
 *
 * @namespace routes.AdminControllers
 * @type {TmrRoute}
 */
export const route = {
  name: 'devices.deviceControllers.list',
  label: 'ADMIN.DEVICECONTROLLERS.MENUTITLE',
  url: '/deviceControllers',
  component: 'tmrAdminDeviceControllers',
  weight: 5,
  resourceType: 'DeviceController',
  resourceList: {
    searchParameters: ['type', 'code', 'description'],
  },
  resolve: {
    deviceControllerTypes: /*@ngInject*/ tmrDeviceControllerTypes =>
      tmrDeviceControllerTypes,
  },
}

/**
 * Component for {@link routes.tmrAdminDeviceControllers Administer Device Controllers route}
 *
 * @type {ngComponent}
 */
export const tmrAdminDeviceControllers = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminDeviceControllersController',
  bindings: resourceListBindings({
    deviceControllerTypes: '<',
  }),
}

/**
 * Controller of component {@link tmrAdminDeviceControllers}.
 *
 * @type {ngController}
 */
export class tmrAdminDeviceControllersController {
  static ngType = 'controller'

  constructor(DeviceController, TmrCopyToClipboardModal) {
    'ngInject'
    Object.assign(this, { DeviceController, TmrCopyToClipboardModal })
  }

  getApiKey($event, deviceController) {
    return this.TmrCopyToClipboardModal($event, {
      textToCopy: deviceController.$apiKey(),
      fieldLabel: 'ADMIN.DEVICECONTROLLERS.RESOURCELIST.APIKEY',
      successLabel: 'ADMIN.DEVICECONTROLLERS.APIKEYMODAL.SUCCESS',
    })
  }
}
